//Spinner Docs: http://indigojs.github.io/bootstrap-spinner/
import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';

export default class Item extends Component {
  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      isAdded: false
    };
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  addToCart() {
    this.setState({ isAdded: true}, function() {
      setTimeout(() => {
          this.setState({ isAdded: false });
      }, 1200);
    });
  }

  render() {
    return (
      <div className="card">
        <img className="card-img-top" src={this.props.a.image} alt="" />
          <div className="card-body">
            <h5 className="card-title">{this.props.a.name}</h5>
            <p className={this.props.a.sale ? "crossoutprice": "addspace"}>₺{ this.props.a.price.toFixed(2)}</p>
            <p className={this.props.a.sale ? "colorprice": ""}>{this.props.a.sale ? "₺"+ this.props.a.discountprice.toFixed(2)+ " ": ""}</p>
              
          </div>

      </div>
    )
  }
}
